import type { SimulatorArea } from '@vedalib/editor/lib/elements'
import cn from 'classnames'

import type { ResizeDirection } from 'components/Editor/EditorElements/elements/Simulator/useSelectAreaActions'

import { useSimulatorContext } from '../SimulatorContext'
import * as s from './ResizerHandlers.module.scss'

const OFFSET = -2
interface IResizerHandlersProps {
  selected: boolean
  area: SimulatorArea
}

const handlers: { style: React.CSSProperties; direction: ResizeDirection }[] = [
  { style: { left: OFFSET, top: OFFSET, cursor: 'nwse-resize' }, direction: 'top-left' },
  { style: { right: OFFSET, top: OFFSET, cursor: 'nesw-resize' }, direction: 'top-right' },
  { style: { left: OFFSET, bottom: OFFSET, cursor: 'nesw-resize' }, direction: 'bottom-left' },
  { style: { right: OFFSET, bottom: OFFSET, cursor: 'nwse-resize' }, direction: 'bottom-right' },
]

const ResizerHandlers = ({ selected, area }: IResizerHandlersProps) => {
  const styles = useSimulatorContext((c) => c.styles)
  const onResize = useSimulatorContext((c) => c.onResize)
  return handlers.map((handler, index) => (
    <div
      className={cn(s.root, { [s.visible]: selected })}
      key={index}
      onMouseDown={(e) => onResize(e, area, handler.direction)}
      style={{ ...handler.style, borderColor: area.itemId ? styles?.area.borderColor : undefined }}
    />
  ))
}

export default ResizerHandlers
